<script>
    import { createEventDispatcher } from 'svelte';
    import Icon from '../icons/Icon.svelte';

    export let show = false;
    export let selectedTable = null;
    export let closePaymentMethod = 'PIX';
    export let closeDiscount = 0;
    export let closeIncludeService = false;
    export let splitPeopleCount = 2;
    export let currentSubtotal = 0;
    export let currentServiceFee = 0;
    export let currentBillTotal = 0;
    export let currentPayments = [];
    export let splitTotalPaid = 0;
    export let splitRemaining = 0;
    export let equalPerPerson = 0;
    export let isProcessingClose = false;

    const dispatch = createEventDispatcher();

    function formatCurrency(val) {
        const num = parseFloat(val);
        return isNaN(num) ? '0,00' : num.toFixed(2).replace('.', ',');
    }

    function handleClose() {
        dispatch('close');
    }

    function handlePrintPreBill() {
        dispatch('printPreBill');
    }

    function handleOpenSplit() {
        dispatch('openSplit');
    }

    function handleConfirm() {
        dispatch('confirmClose');
    }
</script>

{#if show && selectedTable && selectedTable.comanda}
    <div class="modal-overlay">
        <div class="modal-card close-bill-modal">
            <div class="modal-header">
                <div class="modal-title-wrap">
                    <span class="modal-pretitle">Fechamento de Mesa</span>
                    <h3>Fechar Conta • {selectedTable.label}</h3>
                </div>
                <button class="close-btn" on:click={handleClose}><Icon name="x" size={16} /></button>
            </div>
            <div class="modal-body">
                <div class="bill-breakdown">
                    <div class="bill-row">
                        <span>Consumo Produtos:</span>
                        <strong>R$ {formatCurrency(currentSubtotal)}</strong>
                    </div>
                    <label class="service-fee-row" style="margin: 0; padding: 0;">
                        <span style="display: flex; align-items: center; gap: 6px;">
                            <input type="checkbox" bind:checked={closeIncludeService} />
                            <span>Serviço 10% (Opcional):</span>
                        </span>
                        <strong>R$ {formatCurrency(currentServiceFee)}</strong>
                    </label>
                    {#if closeDiscount > 0}
                        <div class="bill-row" style="color: #059669;">
                            <span>Desconto Aplicado:</span>
                            <strong>- R$ {formatCurrency(closeDiscount)}</strong>
                        </div>
                    {/if}
                    <div class="bill-row total">
                        <span>Total Geral:</span>
                        <span class="total-big">R$ {formatCurrency(currentBillTotal)}</span>
                    </div>

                    {#if currentPayments.length > 0}
                        <div class="summary-divider" style="margin: 8px 0;"></div>
                        <div class="bill-row" style="color: #059669;">
                            <span>Já Recebido:</span>
                            <strong style="color: #059669;">R$ {formatCurrency(splitTotalPaid)}</strong>
                        </div>
                        <div class="bill-row" style="color: #FF6A00; font-size: 14.5px; font-weight: 800;">
                            <span>Saldo Restante:</span>
                            <strong style="color: #FF6A00; font-size: 16.5px;">R$ {formatCurrency(splitRemaining)}</strong>
                        </div>
                    {/if}
                </div>

                <!-- PRÉ-CONTA RÁPIDA -->
                <div class="prebill-quick-action">
                    <button 
                        type="button" 
                        class="btn-action-outline print prebill-btn-quick" 
                        on:click={handlePrintPreBill}
                    >
                        <Icon name="printer" size={15} />
                        <span>Imprimir Pré-Conta (80mm)</span>
                    </button>
                </div>

                <!-- DIVISÃO SIMPLES DA CONTA (ASSISTÊNCIA OPERACIONAL) -->
                <div class="quick-split-box">
                    <div class="quick-split-header">
                        <span class="quick-split-title">
                            <Icon name="users" size={14} />
                            <span>Dividir igualmente:</span>
                        </span>
                        <div class="stepper-mini">
                            <button 
                                type="button" 
                                class="btn-step-mini" 
                                on:click={() => { if (splitPeopleCount > 1) splitPeopleCount--; }}
                                title="Diminuir pessoas"
                            >-</button>
                            <span class="step-mini-val">{splitPeopleCount} pes.</span>
                            <button 
                                type="button" 
                                class="btn-step-mini" 
                                on:click={() => { if (splitPeopleCount < 20) splitPeopleCount++; }}
                                title="Aumentar pessoas"
                            >+</button>
                        </div>
                    </div>
                    <div class="quick-split-val-row">
                        <span class="quick-split-lbl">Cada pessoa paga:</span>
                        <strong class="quick-split-amount">R$ {formatCurrency(equalPerPerson)}</strong>
                    </div>
                </div>

                <div class="field">
                    <label for="pay-method">Forma de Pagamento:</label>
                    <select id="pay-method" bind:value={closePaymentMethod}>
                        <option value="PIX">PIX (Chave ou QR Code)</option>
                        <option value="Cartão de Crédito">Cartão de Crédito</option>
                        <option value="Cartão de Débito">Cartão de Débito</option>
                        <option value="Dinheiro">Dinheiro (Espécie)</option>
                        <option value="VR / Vale Refeição">VR / Vale Refeição</option>
                    </select>
                </div>

                <div class="field">
                    <label for="discount-val">Desconto Especial (R$):</label>
                    <input id="discount-val" type="number" step="0.01" min="0" bind:value={closeDiscount} />
                </div>

                <div class="advanced-split-link-row">
                    <span class="advanced-split-hint">Divisão avançada por itens/pessoas?</span>
                    <button 
                        type="button" 
                        class="btn-action-outline split-action-btn" 
                        on:click={handleOpenSplit}
                    >
                        <Icon name="users" size={13} />
                        <span>Abrir Divisão Completa</span>
                    </button>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn-cancel" on:click={handleClose}>Voltar</button>
                <button class="btn-primary" on:click={handleConfirm} disabled={isProcessingClose}>
                    {#if isProcessingClose}
                        Processando...
                    {:else if splitRemaining <= 0 && currentPayments.length > 0}
                        Liberar Mesa (Conta Já Paga)
                    {:else if currentPayments.length > 0}
                        Confirmar Recebimento de R$ {formatCurrency(splitRemaining)} & Liberar Mesa
                    {:else}
                        Confirmar Recebimento & Liberar Mesa
                    {/if}
                </button>
            </div>
        </div>
    </div>
{/if}

<style>
    .modal-overlay {
        position: fixed;
        inset: 0;
        background: rgba(15, 23, 42, 0.6);
        backdrop-filter: blur(4px);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 9999;
        animation: fadeIn 0.15s ease-out;
    }

    @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
    }

    .modal-card.close-bill-modal {
        background: #FFFFFF;
        border-radius: 16px;
        width: 90%;
        max-width: 480px;
        box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
        display: flex;
        flex-direction: column;
        overflow: hidden;
        border: 1px solid #E2E8F0;
        animation: slideUp 0.2s cubic-bezier(0.16, 1, 0.3, 1);
    }

    @keyframes slideUp {
        from { transform: translateY(12px) scale(0.98); opacity: 0; }
        to { transform: translateY(0) scale(1); opacity: 1; }
    }

    .modal-header {
        padding: 16px 20px;
        border-bottom: 1px solid #E2E8F0;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .modal-title-wrap {
        display: flex;
        flex-direction: column;
        gap: 2px;
    }

    .modal-pretitle {
        font-size: 11px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        color: #FF6A00;
    }

    .modal-header h3 {
        margin: 0;
        font-size: 16px;
        font-weight: 800;
        color: #0F172A;
    }

    .close-btn {
        background: transparent;
        border: none;
        color: #64748B;
        cursor: pointer;
        padding: 6px;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.15s ease;
    }

    .close-btn:hover {
        background: #F1F5F9;
        color: #0F172A;
    }

    .modal-body {
        padding: 20px;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        gap: 14px;
    }

    .bill-breakdown {
        background: #F8FAFC;
        border: 1px solid #E2E8F0;
        border-radius: 12px;
        padding: 14px 16px;
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .bill-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 13.5px;
        color: #475569;
    }

    .bill-row strong {
        color: #0F172A;
        font-weight: 700;
    }

    .service-fee-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 13px;
        color: #475569;
        cursor: pointer;
    }

    .service-fee-row input[type="checkbox"] {
        accent-color: #FF6A00;
        cursor: pointer;
    }

    .bill-row.total {
        margin-top: 4px;
        padding-top: 10px;
        border-top: 1.5px solid #CBD5E1;
        font-size: 15px;
        font-weight: 800;
        color: #0F172A;
    }

    .total-big {
        font-size: 20px;
        font-weight: 900;
        color: #FF6A00;
    }

    .summary-divider {
        height: 1px;
        background: #E2E8F0;
    }

    .prebill-quick-action {
        display: flex;
    }

    .prebill-btn-quick {
        width: 100%;
        justify-content: center;
        padding: 9px 14px;
        border-radius: 8px;
        font-size: 12.5px;
        font-weight: 700;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        gap: 8px;
        border: 1.5px solid #CBD5E1;
        background: #FFFFFF;
        color: #334155;
        transition: all 0.2s ease;
    }

    .prebill-btn-quick:hover {
        background: #F8FAFC;
        border-color: #94A3B8;
        color: #0F172A;
    }

    .quick-split-box {
        background: #FFFFFF;
        border: 1px solid #E2E8F0;
        border-radius: 10px;
        padding: 10px 14px;
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .quick-split-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .quick-split-title {
        font-size: 12.5px;
        font-weight: 700;
        color: #334155;
        display: flex;
        align-items: center;
        gap: 6px;
    }

    .stepper-mini {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        background: #F1F5F9;
        padding: 3px 6px;
        border-radius: 6px;
        border: 1px solid #E2E8F0;
    }

    .btn-step-mini {
        width: 22px;
        height: 22px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #FFFFFF;
        border: 1px solid #CBD5E1;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 700;
        color: #334155;
        cursor: pointer;
        line-height: 1;
        transition: all 0.15s ease;
        user-select: none;
    }

    .btn-step-mini:hover {
        background: #FF6A00;
        color: #FFFFFF;
        border-color: #FF6A00;
    }

    .step-mini-val {
        font-weight: 800;
        font-size: 13px;
        color: #FF6A00;
        min-width: 28px;
        text-align: center;
    }

    .quick-split-val-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 6px;
        border-top: 1px dashed #CBD5E1;
        font-size: 13px;
    }

    .quick-split-lbl {
        color: #64748B;
        font-size: 12px;
    }

    .quick-split-amount {
        color: #FF6A00;
        font-size: 15px;
        font-weight: 800;
    }

    .field {
        display: flex;
        flex-direction: column;
        gap: 6px;
    }

    .field label {
        font-size: 12.5px;
        font-weight: 700;
        color: #334155;
    }

    .field select,
    .field input {
        width: 100%;
        padding: 9px 12px;
        background: #F8FAFC;
        border: 1.5px solid #CBD5E1;
        border-radius: 8px;
        font-size: 13.5px;
        color: #0F172A;
        box-sizing: border-box;
        transition: all 0.2s ease;
    }

    .field select:focus,
    .field input:focus {
        outline: none;
        background: #FFFFFF;
        border-color: #FF6A00;
        box-shadow: 0 0 0 3px rgba(255, 106, 0, 0.12);
    }

    .advanced-split-link-row {
        margin-top: 4px;
        padding-top: 10px;
        border-top: 1px dashed #E2E8F0;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .advanced-split-hint {
        font-size: 12px;
        color: #64748B;
    }

    .split-action-btn {
        padding: 6px 12px;
        font-size: 12px;
        display: inline-flex;
        align-items: center;
        gap: 6px;
        background: #FFF4EC;
        border: 1px solid #FED7AA;
        color: #FF6A00;
        border-radius: 6px;
        cursor: pointer;
        font-weight: 700;
        transition: all 0.15s ease;
    }

    .split-action-btn:hover {
        background: #FFEDD5;
        border-color: #FB923C;
    }

    .modal-footer {
        padding: 14px 20px;
        border-top: 1px solid #E2E8F0;
        display: flex;
        justify-content: flex-end;
        gap: 10px;
        background: #F8FAFC;
    }

    .btn-cancel {
        padding: 9px 16px;
        background: #FFFFFF;
        border: 1.5px solid #CBD5E1;
        border-radius: 8px;
        font-size: 13px;
        font-weight: 700;
        color: #475569;
        cursor: pointer;
        transition: all 0.2s ease;
    }

    .btn-cancel:hover {
        background: #F1F5F9;
        color: #0F172A;
    }

    .btn-primary {
        padding: 9px 18px;
        background: #FF6A00;
        border: 1.5px solid #FF6A00;
        border-radius: 8px;
        font-size: 13px;
        font-weight: 800;
        color: #FFFFFF;
        cursor: pointer;
        box-shadow: 0 2px 4px rgba(255, 106, 0, 0.2);
        transition: all 0.2s ease;
    }

    .btn-primary:hover:not(:disabled) {
        background: #E65F00;
        border-color: #E65F00;
        box-shadow: 0 4px 8px rgba(255, 106, 0, 0.3);
    }

    .btn-primary:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }

    @media (max-width: 767.98px) {
        .modal-card.close-bill-modal {
            width: 100vw !important;
            max-width: 100vw !important;
            height: 100vh !important;
            height: 100dvh !important;
            max-height: 100dvh !important;
            border-radius: 0 !important;
            margin: 0 !important;
            padding: 0 !important;
            display: flex !important;
            flex-direction: column !important;
            position: fixed !important;
            inset: 0 !important;
            z-index: 10001 !important;
            background: #FFFFFF !important;
        }

        .close-bill-modal .modal-header {
            padding: 12px 14px !important;
            border-bottom: 1px solid #E2E8F0 !important;
            background: #FFFFFF !important;
            flex-shrink: 0 !important;
        }

        .close-bill-modal .modal-body {
            flex: 1 !important;
            overflow-y: auto !important;
            padding: 14px 14px 100px 14px !important;
            -webkit-overflow-scrolling: touch !important;
            box-sizing: border-box !important;
        }

        .close-bill-modal .modal-footer {
            position: fixed !important;
            bottom: 0 !important;
            left: 0 !important;
            right: 0 !important;
            background: #FFFFFF !important;
            border-top: 1.5px solid #E2E8F0 !important;
            padding: 10px 14px calc(10px + env(safe-area-inset-bottom, 0px)) 14px !important;
            box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.1) !important;
            z-index: 10002 !important;
            display: flex !important;
            gap: 8px !important;
        }

        .close-bill-modal .modal-footer button {
            min-height: 48px !important;
            font-size: 13.5px !important;
            font-weight: 800 !important;
            border-radius: 10px !important;
            touch-action: manipulation;
        }

        .close-bill-modal .modal-footer .btn-primary {
            flex: 1 !important;
        }

        .prebill-btn-quick {
            min-height: 46px !important;
            font-size: 13.5px !important;
            font-weight: 700 !important;
            border-radius: 10px !important;
            touch-action: manipulation;
        }

        .quick-split-box {
            padding: 12px 14px !important;
            border-radius: 10px !important;
        }

        .quick-split-title {
            font-size: 13px !important;
        }

        .quick-split-amount {
            font-size: 16px !important;
        }
    }
</style>
